import React, { useState,useEffect } from 'react';
import { motion } from 'framer-motion';
import {
  PageContainer,
  PageHeader,
  PageTitle,
  PageIcon,
  PageDescription,
  ContentGrid,
  ContentRow,
  Card,
  CardTitle,
  CardContent,
  ActionBar,
  Button,
  SearchInput,
  Table,
  TableHeader,
  TableRow,
  TableCell,
  StatusBadge,
  TabContainer,
  TabList,
  Tab,
  TabContent,
  fadeIn,
  formatDate
} from '../styles/PageStyles';
import { faDiagramPredecessor } from '@fortawesome/free-solid-svg-icons';
import PageHeaderWithInfo from '../components/common/PageHeaderWithInfo';
import { useAuth } from '../context/AuthContext';
import { getDataSourceCount, getDataSources } from '../services/dataSourceService';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/common/Pagination';
import { usePermission } from '../context/PermissionContext';

const DataSources = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { user } = useAuth();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('connections');
  const [dataSources, setdataSources] = useState([]);

  
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const { permissions, permissionEnum, loading } = usePermission();


  const userAccessPermissions = permissions?.length
    ? permissions
      .filter(ele => ele.component_type === "data_source")
      .map(ele => ele.permission)
    : [];
  
  const itemsPerPage = 10;

  // Mock data for data pipelines
  const dataPipelines = [
    {
      id: 'PL-001',
      name: 'Claims ETL',
      source: 'Claims Database',
      destination: 'Knowledge Base',
      status: 'running',
      lastRun: '2025-03-17 15:30',
      frequency: 'Hourly',
      recordsProcessed: '125K',
      duration: '12m 30s'
    },
    {
      id: 'PL-002',
      name: 'Customer Data Integration',
      source: 'Customer CRM',
      destination: 'Knowledge Base',
      status: 'running',
      lastRun: '2025-03-17 14:00',
      frequency: 'Hourly',
      recordsProcessed: '85K',
      duration: '8m 45s'
    },
    {
      id: 'PL-003',
      name: 'Document Processing',
      source: 'Document Storage',
      destination: 'Document Queue',
      status: 'running',
      lastRun: '2025-03-17 12:00',
      frequency: 'Hourly',
      recordsProcessed: '32K',
      duration: '15m 20s'
    },
    {
      id: 'PL-004',
      name: 'Provider Network Sync',
      source: 'Provider Network',
      destination: 'Knowledge Base',
      status: 'failed',
      lastRun: '2025-03-16 18:22',
      frequency: 'Daily',
      recordsProcessed: '0',
      duration: '2m 10s'
    },
  ];
  useEffect(()=>{
    const fetchDataSource = async() => {
      const query = `skip=${(currentPage - 1) * itemsPerPage}&limit=${itemsPerPage}`;
      try {
        
        const response = await getDataSources({},{"created_at":"desc"},query)
        setdataSources(response)
      } catch (error) {
        console.error('Error fetching Data Source data:', error);
        navigate('/login');
      }
    }
    fetchDataSource()
  },[currentPage])


  useEffect(() => {
    try {
      const fetchCountOfDataSource = async () => {
        const count = await getDataSourceCount();
        setTotalItems(count);
      }

      fetchCountOfDataSource();
    } catch (error) {
      console.log("Error while fetching the data source count", error)
    }
  }, [])

  const handleNavigate = (connectorId) => {
    navigate(`/data-sources-details/${connectorId}`);
  };
  // Filter data sources based on search term
  // const filteredDataSources = (searchTerm) => {
  //   const fetchDataSource = async() => {
  //     const query = `skip=${(currentPage - 1) * itemsPerPage}&limit=${itemsPerPage}`;
  //     try {
        
  //       const response = await getDataSources({},{"created_at":"asc"},query)
  //       setdataSources(response)
  //     } catch (error) {
  //       console.error('Error fetching Data Source data:', error);
  //       navigate('/login');
  //     }
  //   }
  //   return dataSources
  // }
  const filteredDataSources = dataSources.filter(source => {
    return (source.name?.toLowerCase().includes(searchTerm.toLowerCase()) || false) ||
           (source.type?.toLowerCase().includes(searchTerm.toLowerCase()) || false) ||
           (source.connector?.toLowerCase().includes(searchTerm.toLowerCase()) || false)
  });


  // Filter data pipelines based on search term
  const filteredDataPipelines = dataPipelines.filter(pipeline =>
    pipeline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pipeline.source.toLowerCase().includes(searchTerm.toLowerCase()) ||
    pipeline.destination.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Get status badge color
  const getStatusColor = (status) => {
    switch (status) {
      case 'connected': return 'active';
      case 'warning': return 'warning';
      case 'disconnected': return 'error';
      case 'running': return 'active';
      case 'failed': return 'error';
      case 'paused': return 'warning';
      default: return 'default';
    }
  };

  return (
    <PageContainer>
      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
      >
        <PageHeaderWithInfo
          icon={faDiagramPredecessor}
          title="Data Sources"
          description="Connect, manage, and monitor all data sources that feed into the AI system.
          Set up data pipelines, configure refresh rates, and ensure data quality for optimal AI performance."
        >
          <div style={{ display: 'flex', gap: '1rem' }}>
            <SearchInput
              type="text"
              placeholder={activeTab === 'connections' ? "Search data sources..." : "Search pipelines..."}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {/* <Button>Test Connection</Button> */}
            { userAccessPermissions.includes(permissionEnum.CREATE) && <Button primary onClick={(e)=>{handleNavigate('new')}}>Add Data Source</Button> }
          </div>
        </PageHeaderWithInfo>


        <TabContainer>
          {/* <TabList>
            <Tab active={activeTab === 'connections'} onClick={() => setActiveTab('connections')}>Connections</Tab>
            <Tab active={activeTab === 'pipelines'} onClick={() => setActiveTab('pipelines')}>Data Pipelines</Tab>
            <Tab active={activeTab === 'monitoring'} onClick={() => setActiveTab('monitoring')}>Monitoring</Tab>
          </TabList> */}

          {/* <ActionBar>
            
            <Button>Filter</Button>
            <Button>Sort</Button>
          </ActionBar> */}

          <TabContent active={activeTab === 'connections'}>
            <Card>
              {/* <CardTitle>Data Source Connections</CardTitle> */}
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Name</TableHeader>
                    {/* <TableHeader>Type</TableHeader> */}
                    <TableHeader>Connector</TableHeader>
                    <TableHeader>Last Sync</TableHeader>
                    <TableHeader>Data Volume(in Gb)</TableHeader>
                    <TableHeader>Refresh Rate</TableHeader>
                    <TableHeader>Owner</TableHeader>
                    <TableHeader>Status</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {filteredDataSources.map(source => (
                    <TableRow key={source.id}>
                      <TableCell>{source.name}</TableCell>
                      {/* <TableCell>{source.type}</TableCell> */}
                      <TableCell>{source.connector}</TableCell>
                      <TableCell>{formatDate(source.updated_at)}</TableCell>
                      <TableCell>{source.data_volume_in_gb}</TableCell>
                      <TableCell>{source.refresh_rate_duration}</TableCell>
                      <TableCell>{source.created_by}</TableCell>
                      <TableCell>
                        <StatusBadge status={getStatusColor(source.status)}>
                          {source.status.charAt(0).toUpperCase() + source.status.slice(1)}
                        </StatusBadge>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>


                          <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }} onClick={(e) => { handleNavigate(source.code) }}>
                            {
                              userAccessPermissions.includes(permissionEnum.CREATE) || userAccessPermissions.includes(permissionEnum.UPDATE) ? 'Configure' : 'View'
                            }
                          </Button>
                          {/* <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Sync Now</Button> */}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
              <Pagination
                  currentPage={currentPage}
                  pageSize={itemsPerPage}
                  totalPages={totalPages}
                  totalCount={totalItems}
                  setCurrentPage={setCurrentPage}
                  setTotalPages={setTotalPages}
              />
            </Card>
          </TabContent>

          <TabContent active={activeTab === 'pipelines'}>
            <Card>
              <CardTitle>Data Pipelines</CardTitle>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>ID</TableHeader>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Source</TableHeader>
                    <TableHeader>Destination</TableHeader>
                    <TableHeader>Last Run</TableHeader>
                    <TableHeader>Frequency</TableHeader>
                    <TableHeader>Records Processed</TableHeader>
                    <TableHeader>Duration</TableHeader>
                    <TableHeader>Status</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {filteredDataPipelines.map(pipeline => (
                    <TableRow key={pipeline.id}>
                      <TableCell>{pipeline.id}</TableCell>
                      <TableCell>{pipeline.name}</TableCell>
                      <TableCell>{pipeline.source}</TableCell>
                      <TableCell>{pipeline.destination}</TableCell>
                      <TableCell>{pipeline.lastRun}</TableCell>
                      <TableCell>{pipeline.frequency}</TableCell>
                      <TableCell>{pipeline.recordsProcessed}</TableCell>
                      <TableCell>{pipeline.duration}</TableCell>
                      <TableCell>
                        <StatusBadge status={getStatusColor(pipeline.status)}>
                          {pipeline.status.charAt(0).toUpperCase() + pipeline.status.slice(1)}
                        </StatusBadge>
                      </TableCell>
                      <TableCell>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Edit</Button>
                          {pipeline.status === 'running' ? (
                            <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Pause</Button>
                          ) : pipeline.status === 'failed' ? (
                            <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Retry</Button>
                          ) : (
                            <Button primary style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Start</Button>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </tbody>
              </Table>
            </Card>
          </TabContent>

          <TabContent active={activeTab === 'monitoring'}>
            <ContentGrid>
              <Card>
                <CardTitle>Data Volume by Source</CardTitle>
                <CardContent>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
                    {dataSources.map((source, index) => (
                      <div key={index}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.3rem' }}>
                          <span>{source.name}</span>
                          <span>{source.dataVolume}</span>
                        </div>
                        <div style={{ width: '100%', height: '8px', background: 'rgba(0,102,255,0.1)', borderRadius: '4px' }}>
                          <div
                            style={{
                              width: `${(index === 0 ? 80 : index === 1 ? 60 : index === 2 ? 95 : index === 3 ? 40 : 20)}%`,
                              height: '8px',
                              background: 'var(--primary)',
                              borderRadius: '4px'
                            }}
                          ></div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>

              <Card>
                <CardTitle>Pipeline Performance</CardTitle>
                <CardContent>
                  <div style={{ height: '200px', display: 'flex', alignItems: 'flex-end', gap: '12px', marginTop: '20px' }}>
                    {[85, 92, 78, 88, 95, 82, 90].map((value, index) => (
                      <div key={index} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <div style={{ height: `${value * 1.5}px`, width: '100%', background: 'var(--primary)', borderRadius: '4px 4px 0 0' }}></div>
                        <div style={{ fontSize: '0.7rem', marginTop: '5px' }}>{`D${index + 1}`}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ textAlign: 'center', marginTop: '10px', fontSize: '0.8rem', color: 'var(--text-secondary)' }}>
                    Pipeline Success Rate - Last 7 Days
                  </div>
                </CardContent>
              </Card>
            </ContentGrid>

            <Card style={{ marginTop: '1.5rem' }}>
              <CardTitle>Data Quality Issues</CardTitle>
              <Table>
                <thead>
                  <tr>
                    <TableHeader>Source</TableHeader>
                    <TableHeader>Issue Type</TableHeader>
                    <TableHeader>Affected Records</TableHeader>
                    <TableHeader>First Detected</TableHeader>
                    <TableHeader>Last Detected</TableHeader>
                    <TableHeader>Impact</TableHeader>
                    <TableHeader>Status</TableHeader>
                    <TableHeader>Actions</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  <TableRow>
                    <TableCell>Claims Database</TableCell>
                    <TableCell>Missing Values</TableCell>
                    <TableCell>1,245</TableCell>
                    <TableCell>2025-03-15</TableCell>
                    <TableCell>2025-03-17</TableCell>
                    <TableCell>Medium</TableCell>
                    <TableCell><StatusBadge status="warning">Open</StatusBadge></TableCell>
                    <TableCell><Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Resolve</Button></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Provider Network</TableCell>
                    <TableCell>Connection Timeout</TableCell>
                    <TableCell>All</TableCell>
                    <TableCell>2025-03-16</TableCell>
                    <TableCell>2025-03-17</TableCell>
                    <TableCell>High</TableCell>
                    <TableCell><StatusBadge status="error">Critical</StatusBadge></TableCell>
                    <TableCell><Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Resolve</Button></TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Customer CRM</TableCell>
                    <TableCell>Duplicate Records</TableCell>
                    <TableCell>328</TableCell>
                    <TableCell>2025-03-14</TableCell>
                    <TableCell>2025-03-15</TableCell>
                    <TableCell>Low</TableCell>
                    <TableCell><StatusBadge status="active">Resolved</StatusBadge></TableCell>
                    <TableCell><Button style={{ padding: '0.3rem 0.6rem', fontSize: '0.8rem' }}>Details</Button></TableCell>
                  </TableRow>
                </tbody>
              </Table>
            </Card>
          </TabContent>
        </TabContainer>
{/* 
        <Card style={{ marginTop: '2rem' }}>
          <CardTitle>Data Integration Architecture</CardTitle>
          <CardContent>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginTop: '1.5rem',
              padding: '0 2rem'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '10px',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: '0.5rem'
                }}>
                  <div style={{ fontSize: '2rem' }}>⌗</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Data Sources</div>
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '150px' }}>
                  External and internal data repositories
                </div>
              </div>

              <div style={{ fontSize: '2rem', color: 'var(--primary)' }}>→</div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '10px',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: '0.5rem'
                }}>
                  <div style={{ fontSize: '2rem' }}>⌲</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Data Pipelines</div>
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '150px' }}>
                  ETL processes and data transformations
                </div>
              </div>

              <div style={{ fontSize: '2rem', color: 'var(--primary)' }}>→</div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '10px',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: '0.5rem'
                }}>
                  <div style={{ fontSize: '2rem' }}>⌘</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>Knowledge Base</div>
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '150px' }}>
                  Structured information for AI consumption
                </div>
              </div>

              <div style={{ fontSize: '2rem', color: 'var(--primary)' }}>→</div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '1rem'
              }}>
                <div style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '10px',
                  background: 'rgba(0, 102, 255, 0.1)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: '0.5rem'
                }}>
                  <div style={{ fontSize: '2rem' }}>⚇</div>
                  <div style={{ fontSize: '0.9rem', fontWeight: 'bold' }}>AI Agents</div>
                </div>
                <div style={{ fontSize: '0.8rem', color: 'var(--text-secondary)', textAlign: 'center', maxWidth: '150px' }}>
                  Intelligent processing and decision making
                </div>
              </div>
            </div>
          </CardContent>
        </Card> */}
      </motion.div>
    </PageContainer>
  );
};

export default DataSources;
